import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { Funcionario } from './funcionario'

type ZodFaltaCadastrada = z.infer<typeof zod.FaltaCadastradaSchema>

export type FaltaJustificada = Omit<
    ZodFaltaCadastrada,
    'justificativa' | 'fileUrl'
> & {
    justificativa: string
    fileUrl: string | null
}

export type FaltaInjustificada = Omit<
    ZodFaltaCadastrada,
    'justificativa' | 'fileUrl'
> & {
    justificativa?: never
    fileUrl: null
}

export type FaltaCadastrada = (FaltaJustificada | FaltaInjustificada) & {
    Funcionario: Funcionario
}

const UpdateFaltaCadastradaSchema = zod.FaltaCadastradaSchema.omit({
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    data: true,
}).extend({
    data: z.date().or(z.string().refine(Boolean)),
})

export const CreateFaltaCadastradaSchema = UpdateFaltaCadastradaSchema.omit({
    id: true,
    empresaId: true,
    funcionarioId: true,
    fileUrl: true,
})
    .extend({
        isInjustificada: z.boolean().optional(),
        fileUrl: z.any().nullish(),
    })
    .refine(
        data => {
            if (!data.isInjustificada)
                return !!data.justificativa?.trim().length

            return true
        },
        {
            message: 'Justificativa é obrigatória para faltas justificadas',
            path: ['justificativa'],
        },
    )

export const faltasCadastradas = new ApiService<FaltaCadastrada>(
    'faltas-cadastradas',
)
